import { render } from "./contextMenu.vue?vue&type=template&id=126a5b0c&scoped=true"
import script from "./contextMenu.vue?vue&type=script&lang=js"
export * from "./contextMenu.vue?vue&type=script&lang=js"

import "./contextMenu.vue?vue&type=style&index=0&id=126a5b0c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126a5b0c"]])

export default __exports__